import { render, staticRenderFns } from "./leftPie.vue?vue&type=template&id=d1045e7c&scoped=true&"
import script from "./leftPie.vue?vue&type=script&lang=js&"
export * from "./leftPie.vue?vue&type=script&lang=js&"
import style0 from "./leftPie.vue?vue&type=style&index=0&id=d1045e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1045e7c",
  null
  
)

export default component.exports